<template>
  <div class="filters">
    <multiselect
      v-model="selectedVacancy"
      class="big"
      :options="vacancies"
      :show-labels="false"
      :allow-empty="true"
      :searchable="true"
      :internal-search="false"
      :loading="loading_more"
      track-by="id"
      label="name"
      :placeholder="$tr('invites.vacancyFilter')"
      @search-change="asyncFind"
    >
      <template v-if="vacancies_total > vacancies.length" slot="afterList">
        <div class="after-list">
          <vbutton
            :text="$tr('select.button.more')"
            :disabled="loading_more"
            :loading="loading_more"
            @click="load_more"
          />
        </div>
      </template>
    </multiselect>

    <multiselect
      v-model="selectedStatuses"
      class="big"
      :options="statuses"
      :show-labels="false"
      :allow-empty="true"
      :searchable="true"
      track-by="id"
      label="name"
      :placeholder="$tr('invites.statusesFilter')"
    />
  </div>
</template>

<script>
  import debounce from 'debounce';
  import { orderBy } from 'lodash';

  export default {
    name: 'InviteFilterPanel',

    data() {
      return {
        loading_more: false,
        searchTerm: '',
        count: 20
      };
    },

    computed: {
      ...mapState('vacancies', ['vacancies_total', 'list_dropdown']),
      ...mapGetters({
        company: 'company/one',
        filters: 'invites/filters'
      }),

      statuses() {
        const label = this.$tr('invites.statusesFilter');

        return [{ id: 0, name: label }].concat(this.$store.getters['dictionary/responseStatuses']);
      },

      vacancies() {
        const label = this.$tr('analytics.filters.vacancy');
        let vacanciesArr = this.list_dropdown;
        let vacancies = [{ id: 0, name: label }, ...vacanciesArr];

        return vacancies;
      },

      selectedVacancy: {
        get() {
          const id = this.filters.vacancyId;

          return this.vacancies.find(i => i.id === id);
        },

        set(val) {
          this.update({
            vacancyId: val ? val.id : null
          });
          this.$emit('vacancySelect', val);
        }
      },

      selectedStatuses: {
        get() {
          const id = this.filters.responseStatusId;

          return this.statuses.find(i => i.id === id);
        },

        set(val) {
          this.update({
            responseStatusId: val ? val.id : null
          });
          this.$emit('setStatus', val ? val.id : null);
        }
      }
    },

    watch: {
      company(val, oldVal) {
        if (val && (!oldVal || !oldVal.id)) {
          this.fetch();
        }
      }
    },

    beforeMount() {
      this.CHANGE_PAGINATION_COUNT(20);
      this.fetch();
    },

    beforeDestroy() {
      this.CHANGE_PAGINATION_COUNT(20);
    },

    methods: {
      ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),
      ...mapActions('vacancies', ['fetchVacanciesListDropdown']),
      fetch() {
        this.loading_more = true;
        let params = {
          searchTerm: this.searchTerm
        };
        this.fetchVacanciesListDropdown(params)
          .then(() => {
            this.loading_more = false;
          })
          .catch(() => {
            this.loading_more = false;
          });
      },

      asyncFind: debounce(function (v) {
        this.searchTerm = v;
        this.fetch();
      }, 500),

      load_more(is_active = true) {
        this.count = this.count + 20;
        this.CHANGE_PAGINATION_COUNT(this.count);
        this.fetch();
      },

      update(data) {
        this.$store.dispatch('invites/updateFilters', data);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .standart-navigation .actions .filters {
    margin-left: 20px;
    flex: 1;
  }
  .filters {
    ::v-deep {
      .after-list {
        padding: 10px;
        border-top: 1px solid #ccc;
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
